import { Close as ResetIcon, Search as SearchIcon } from "@mui/icons-material";
import { Box, IconButton, Stack, TextField } from "@mui/material";
import type { FC } from "react";
import AgentSelect from "../sharedComponents/agentSelect/AgentSelect";

export interface TaskFilters {
  readonly query: string;
  readonly assignedUserId: string | null;
}

interface Props {
  readonly filters: TaskFilters;
  readonly onChange: (filters: Partial<TaskFilters>) => void;
  readonly onClear: () => void;
}

const TaskSearch: FC<Props> = ({ filters, onChange, onClear }) => {
  return (
    <Stack direction="row" sx={{ alignItems: "center" }} spacing={2}>
      <SearchIcon />
      <Box sx={{ flexBasis: 0, flexGrow: 5 }}>
        <TextField
          fullWidth
          value={filters.query}
          label="Szukaj w opisie"
          onChange={(e) => onChange({ query: e.target.value ?? "" })}
        />
      </Box>
      <Box sx={{ flexBasis: 0, flexGrow: 3 }}>
        <AgentSelect
          label="Przypisane do"
          agentId={filters.assignedUserId}
          onChange={(assignedUserId) => onChange({ assignedUserId })}
        />
      </Box>
      <IconButton color="inherit" onClick={onClear} aria-label="Wyczyść filtry">
        <ResetIcon />
      </IconButton>
    </Stack>
  );
};

export default TaskSearch;
